import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatRadioChange } from '@angular/material/radio';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { SmsComponent } from '@app/@shared/dialogs/SMS/sms.component';
import { TranslateService } from '@ngx-translate/core';
import { IneDTO, IneDTOcall, ParticipantIneDTO } from '../model/ine-model';
import { Operation, ParticipantVSDTO, PrintContractDTO, VideoSelfingDTO } from '@app/requests/model/requests-model';
import { IneSignatureStore } from './services/ine-signature.store';
import { UserType } from '@app/@core/constants/user-credentials.constants';
import { CredentialsService } from '@app/login';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { validateLocaleAndSetLanguage } from 'typescript';
import { URL_REQUESTS_PENDING_VIDEOSELFING } from '@app/@core/constants/routes.constants';
import { RequestsGetDataStore } from '../requests-get-data-service/requests-get-data.store';

@Component({
  selector: 'ine-signature',
  templateUrl: './ine-signature.component.html',
  styleUrls: ['./ine-signature.component.scss'],
})
export class IneSignatureComponent implements OnInit {
  numOperation: string;
  public pendingForm: FormGroup;
  dataSource = new MatTableDataSource<ParticipantIneDTO>();
  displayedColumns: string[] = [
    'select',
    'physicalId',
    'name',
    'firstSurname',
    'lastSurname',
    'ineSigned',
    'smsAttempts',
  ];
  selection = new SelectionModel<any>(false, []);
  data: IneDTOcall | VideoSelfingDTO;
  dataVideoSelfing: VideoSelfingDTO;
  isVideoSelfing: boolean = false;
  printIne: PrintContractDTO;
  selectedValue: ParticipantIneDTO;
  public noPhone: boolean;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public translate: TranslateService,
    private ineSignatureStore: IneSignatureStore,
    private requestDataStore: RequestsGetDataStore
  ) {}

  ngOnInit(): void {
    this.createForm();

    if (this.router.url === URL_REQUESTS_PENDING_VIDEOSELFING) {
      this.dataVideoSelfing = this.requestDataStore.getOperationVideoselfing();
      this.isVideoSelfing = true;
      this.loadParticipantsVideoSelfing();
    } else {
      // ine
      this.isVideoSelfing = false;
      this.data = this.ineSignatureStore.getRequestIneSelected();
      this.loadParticipants();
    }
  }

  public checkValue(event: MatRadioChange) {
    if (event) {
      this.selection.toggle(event.value);
      this.selectedValue = event.value;
    } else {
      this.selectedValue = null;
    }
  }

  public goToPanel() {
    let pageOpenSignature = JSON.parse(localStorage.getItem('pageOpenSignature'));
    this.router.navigate([pageOpenSignature.url, { keepFilter: true }]);
  }

  public print() {
    this.ineSignatureStore.printIne(this.printIne);
  }

  public sendSMS() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '550px';
    dialogConfig.autoFocus = false;

    //comprobamos que el campo mobile esta vacio
    //otra forma es que desde back nos envien en cada interviniente el parametro noMovil como en la operacion
    if (
      this.selectedValue.mobile === undefined ||
      this.selectedValue.mobile === null ||
      this.selectedValue.mobile === ''
    ) {
      //show dialog noemail
      dialogConfig.data = {
        title: this.translate.instant('dialog.INE.nophone.title'),
        text: this.translate.instant('dialog.INE.nophone.text.participant'),
        icon: 'icon-ic_warning',
      };

      this.dialog.open(ResponseDialogComponent, dialogConfig);
    } else {
      const dialogSMS = this.dialog.open(SmsComponent, dialogConfig);
      dialogSMS.afterClosed().subscribe((dataDialog: any) => {
        if (dataDialog.data) {
          if (this.isVideoSelfing) {
            this.requestDataStore.sendSMSVideoSelfing(this.selectedValue).subscribe((result) => {
              if (result.value === 'OK') {
                this.loadParticipantsVideoSelfing();
                this.pendingForm.reset();
              }
            });
          } else {
            // SMS INE
            this.ineSignatureStore.sendSMS(this.selectedValue).subscribe((result) => {
              if (result.value === 'OK') {
                this.loadParticipants();
                this.pendingForm.reset();
              }
            });
          }
        }
      });
    }
  }

  loadParticipants() {
    this.ineSignatureStore.getparticipantsINE(this.data).subscribe((data: IneDTO) => {
      this.numOperation = data.numOperation;
      this.dataSource.data = data.participants;
      this.noPhone = data.noMobile;
      let dataAux: IneDTOcall = this.data;
      this.printIne = {
        bindOffer: '',
        coBrand: data.comarca,
        codeOperative: data.operative,
        codeProduct: Number(data.financialProduct),
        dateEntry: data.dateEntry,
        isIne: 'S',
        language: data.language,
        notary: '',
        numOperation: data.numOperation,
        versionContract: dataAux.versContrato ? dataAux.versContrato : '',
        versionPolicy: '',
      };
    });
  }

  loadParticipantsVideoSelfing() {
    this.requestDataStore.getparticipantsVideoSelfing(this.dataVideoSelfing).subscribe((data: IneDTO) => {
      this.numOperation = data.numOperation;
      this.dataSource.data = data.participants;
      this.noPhone = data.noMobile;
      this.printIne = {
        bindOffer: '',
        coBrand: data.comarca,
        codeOperative: data.operative,
        codeProduct: Number(data.financialProduct),
        dateEntry: data.dateEntry,
        isIne: 'S',
        language: data.language,
        notary: '',
        numOperation: data.numOperation,
        versionContract: '',
        versionPolicy: '',
      };
    });
  }

  private createForm() {
    this.pendingForm = this.formBuilder.group({
      pending: ['', Validators.required],
    });
  }
}
